export default "__VITE_ASSET__BUEndzdm__"